import gql from "graphql-tag";

export default gql`
	query countAccounts($attributes: FilterAccountsInput) {
		countAccounts(attributes: $attributes)
	}
`;
